import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedNumber } from "@/hooks/metrics/useFormattedNumber";
import { LicenseCheckDisplayData } from "@/pages/license-check-admin/models/LicenseCheckDisplayData";

export function NumberCell(props: GridRenderCellParams<LicenseCheckDisplayData>) {
  const formatted = useFormattedNumber(props.value);

  return <>{formatted}</>;
}
